import { css } from '@emotion/css';

export const root = css`
  text-align: justify;

  &:nth-of-type(n + 2) {
    margin-top: 1rem;
  }
`;
